export default (map, layers, visibility) => {
    layers.forEach((layer) => {
        if (map.getLayer(layer.id)) {
            map.setLayoutProperty(layer.id, 'visibility', visibility, { validate: false });
        }
    });
};



// WEBPACK FOOTER //
// ./map/tier/styleUpdate/updateLayersVisibility.js